export default __webpack_public_path__ + "0a1662cd0f4f840dc77a1417ac6922a7.png";